export default "__VITE_ASSET__DZclYCRN__"